import { optionalEnvValue } from '@/env';
import { createGooglePlacesSearch, type AddressSearch } from '@/shared/google-places';

/**
 * NEX-1168 (plan 2026-10-20 Tarea 2.7) — the address search "Mis depósitos" offers: Google's, when
 * `VITE_APP_GOOGLE_MAPS_API_KEY` is set; `null` otherwise, and the address is typed by hand with no
 * coordinates, exactly as before. The one reason this file reads `@/env` (allow-listed in
 * `.dependency-cruiser.cjs`, like `auth-options.ts`): no `VITE_API_URL`, no `fetch`.
 */
export function getAddressSearch(): AddressSearch | null {
  const apiKey = optionalEnvValue('VITE_APP_GOOGLE_MAPS_API_KEY');
  return apiKey ? createGooglePlacesSearch(apiKey) : null;
}
